import { Button, Icon, Tooltip } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { useFirebase } from 'hooks/firebase/useFirebase'
import React from 'react'

import { RetificacaoAtendimentoButtonModel } from './model-retificacaoAtendimento'

interface RetificacaoAtendimentoButtonProps {
  historicoAtendimento: RetificacaoAtendimentoButtonModel
  onClick(): void
}

function getRetificarAtendimentoTooltip(
  isVersaoFichaRetificavel: boolean,
  isAcessoLotacaoCriadora: boolean,
  isMesmoProfissionalCriadorOutraLotacao: boolean,
  isAtendimentoInativo: boolean
): string {
  if (isAtendimentoInativo) return 'Não é possível retificar um registro removido'

  if (!isVersaoFichaRetificavel) {
    return 'Registros gerados antes da versão "5.3.15" do sistema não podem ser retificados'
  }

  if (!isAcessoLotacaoCriadora) {
    return 'Somente a lotação responsável pelo registro pode retificá-lo'
  }

  if (isMesmoProfissionalCriadorOutraLotacao) {
    return 'É necessário acessar com a lotação que você realizou o registro para retificá-lo'
  }

  return 'Retificar registro'
}

export function RetificacaoAtendimentoButton(props: RetificacaoAtendimentoButtonProps) {
  const { historicoAtendimento, onClick } = props
  const { acesso, profissional: profissionalAcesso } = useAcessoLotacaoOrEstagio()
  const { analytics } = useFirebase()

  const isMesmoProfissional = historicoAtendimento.profissional?.id === profissionalAcesso.id

  const isAcessoLotacaoCriadora =
    isMesmoProfissional &&
    historicoAtendimento.equipe?.id === acesso.equipe?.id &&
    historicoAtendimento.cbo?.id === acesso.cbo?.id &&
    historicoAtendimento.unidadeSaude?.id === acesso.unidadeSaude?.id

  const isMesmoProfissionalCriadorOutraLotacao = isMesmoProfissional && !isAcessoLotacaoCriadora

  const isRetificacaoAtendimentoDisabled =
    !historicoAtendimento.isVersaoFichaRetificavel ||
    !isAcessoLotacaoCriadora ||
    isMesmoProfissionalCriadorOutraLotacao ||
    historicoAtendimento.isInativo

  const retificarAtendimentoTooltip = getRetificarAtendimentoTooltip(
    historicoAtendimento.isVersaoFichaRetificavel,
    isAcessoLotacaoCriadora,
    isMesmoProfissionalCriadorOutraLotacao,
    historicoAtendimento.isInativo
  )

  const handleButtonClick = (e: Event) => {
    e.stopPropagation()
    analytics.logEvent('abrir_modal_RET')
    onClick()
  }

  const handleButtonKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.stopPropagation()
      onClick()
    }
  }

  return (
    <Tooltip text={retificarAtendimentoTooltip}>
      <Button
        size='small'
        skin='ghost'
        disabled={isRetificacaoAtendimentoDisabled}
        onClick={(e) => handleButtonClick(e)}
        onKeyDown={handleButtonKeyDown}
      >
        <Icon icon='penOutline' size={1.5} />
      </Button>
    </Tooltip>
  )
}
